import React from "react";
import "./PortFolio.css";
import img1 from "../Assets/m1.jpg";
import img2 from "../Assets/m2.jpg";

export default function PortFolio() {
  return (
    <section id="portfolio" className="portfolio">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Portfolio</h2>
          <p className="contact-para">Check our latest work</p>
        </div>

        <div className="row" data-aos="fade-up" data-aos-delay="200">
          <div className="col-lg-4 col-md-6">
            <div className=" filter-card">
            <a
              href="https://foodswebapp.netlify.app/"
              target="_blank"
              title="More Details"
            >
              <img src={img2} class="" alt="" />
              <div className="content">
                <h3>Project 01</h3>
              </div>
            </a>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <div className=" filter-card icon-box1">
            <a
              href="https://trawelworlds.netlify.app/"
              target="_blank"
              title="More Details"
            >
              <img src={img1} class="" alt="" />
              <div className="content">
                <h3>Project 02</h3>
              </div>
            </a>
            </div>
          </div>
          {/* <div className="col-lg-4 col-md-6">
            <div className=" filter-card">
            <a
              href="https://logisapp.netlify.app/"
              target="_blank"
              title="More Details"
            >
              <img src={img} class="img-fluid" alt="" />
              <div className="content">
                <h3>Project 03</h3>
              </div>
            </a>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
